import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, styled } from '@mui/material';
import { getYear } from 'date-fns';
const Footer = () => {
    return (_jsx(WrapperBox, { children: _jsxs(RequisitesBox, { children: [_jsx(Typography, { variant: "body1", color: "textMedium", sx: {
                        fontFamily: 'inherit',
                    }, children: "global-parts.su" }), _jsxs(Typography, { variant: "body1", color: "textDisabled", sx: {
                        fontFamily: 'inherit',
                    }, children: ["\u00A9 ", getYear(new Date())] })] }) }));
};
const WrapperBox = styled('footer')(({ theme }) => ({
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(6),
    margin: 'auto',
    background: 'transparent',
}));
const RequisitesBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'GetVoIP Grotesque',
    gap: theme.spacing(4),
}));
export { Footer };
